import React from 'react';
import { useTranslation } from 'react-i18next';
import ApiKeysSidePaneButtonContainer from '@t7x000/apex-web/lib/components/Settings/ApiKeys/index.js';
import ApiKeyListContainer from '@t7x000/apex-web/lib/components/ApiKeysSidePaneComponents/ApiKeyList/ApiKeyListContainer';
import config from '../config';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './APIKeysPage.css';

const apiKeysPageClasses = getBEMClasses('api-keys-page');

const APIKeysPage = () => {
  const { t } = useTranslation();

  return (
    <div className={apiKeysPageClasses()}>
      <div className={apiKeysPageClasses('description-container')}>
        <div className={apiKeysPageClasses('header')}>
          <div className={apiKeysPageClasses('header-title')}>{t('About API Keys')}</div>
          <div className={apiKeysPageClasses('header-text')}>
            {t(
              'The Public API is available in HTTP, WebSocket, and Get Request, with streaming data on products, product pairs, ticker activity, trades, and the order book.',
            )}
          </div>
          <div className={apiKeysPageClasses('header-text')}>
            {t(
              "The Private API is accessible only by registered users and enables access and control of a user's account. All key user functions may be executed from the API, including account and order management activities.",
            )}
          </div>
        </div>
        <div className={apiKeysPageClasses('actions')}>
          <ApiKeysSidePaneButtonContainer />
          <div className={apiKeysPageClasses('documentation')}>
            <a href={config.ApiKeys.documentationLink} target="blank">
              {t('View: API Documentation »')}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className={apiKeysPageClasses('table-header')}>{t('Existing API Keys')}</div>
        <ApiKeyListContainer customClass={'retail-api-key-list'} />
      </div>
    </div>
  );
};

export default APIKeysPage;
